<template>
  <div class="pb-5">
    <Hero titleStrong="About" title="the Foundation" :imageUrl="Image"/>
    <div class="container pb-5">
        <div class="row pt-5">
            <div class="col-12 mb-4">
                <p>The Lorna and Yuti Chernajovsky Biomedical Research Foundation aims to improve public health by providing grants
                  to support high-quality biomedical research into the development of new targeted biomedical therapies in the fields of autoimmunity, inflammation, infectious diseases and ageing.
                </p>
                <p> 
                  The Chernajovsky Foundation works in collaboration with medical research charities
                  and academic institutions that have best practise in peer review. 
                  We do not make grants directly to scientists.
                </p>
            </div>
        </div>
        <div class="row pt-5">
            <div class="col-12 mb-4">
                <p>The Lorna and Yuti Chernajovsky Biomedical Research Foundation was set up in 2019 to
                improve public health by providing grants to support high-quality biomedical research into
                the development of new targeted biomedical therapies. The Foundation's income and assets
                result from royalties from beta-interferon.</p>
            </div>
        </div>
        <div class="row pt-5 justify-content-center">
             <div class="col-12 col-md-8">
                <img class="img-fluid" src='../assets/launch.jpg' alt="Paul-Peter Tak, Lorna Chernajovsky and Yuti Chernajovsky">
                <p class="fs10 bg-blue text-white p-4"> The three trustees of the new Lorna & Yuti Chernajovsky Biomedical Research Foundation at its launch 
                on 23 October 2019 at the House of Lords hosted by Lord Winston.
                From left to right: Paul-Peter Tak, Lorna Chernajovsky and Yuti Chernajovsky.</p>
            </div>
        </div>
        <div class="row pt-5">
            <div class="col-12 text-blue mt-5 pt-5 fs16 text-center font-weight-bold">
                Current Trustees
            </div>
        </div>
        <div class="row pt-5 pb-5">
            <div class="col-12 col-md-6">
                <img class="img-fluid" src='../assets/yuti.jpg' alt="Yuti Chernajovsky">
            </div>
            <div class="col-12 col-md-6 mt-3 mt-md-0">
                <strong class="fs14 fs-sm-12">Yuti Chernajovsky PhD FRCP (Chair)</strong>
                <p class="pt-2">
                is Emeritus Professor of Molecular Medicine at Queen Mary,
                University of London. He trained as a molecular biologist at The Weizmann Institute of Science in Israel,
                and his research activities have included the cloning of several interferons,
                interleukins and their receptors. He contributed to the cloning and development of interferon beta
                as a therapeutic agent and the use of suicidal genes for cancer gene therapy. <br>
                He maintains research interests in the development and design of novel targeted therapeutics
                for the treatment of rheumatoid arthritis and other autoimmune diseases.
                The platform delivery technology led to the establishment of Stealthyx Therapeutics Ltd,
                a spin out company with patents granted worldwide.
                </p>
            </div>
        </div>
         <div class="row pt-5 pb-5">
             <div class="col-12 col-md-6 order-md-2">
                <img class="img-fluid" src='../assets/lorna.jpg' alt="Lorna Chernajovsky">
            </div>
            <div class="col-12 col-md-6 mt-3 mt-md-0">
                <strong class="fs14 fs-sm-12">Lorna Chernajovsky (Layward) PhD</strong>
                <p class="pt-2">
                gained her PhD at Leicester University in the immunology of kidney disease.
                She worked in research institutions undertaking biomedical research before joining national medical research
                charities carrying out grant funding and administration, research strategy and public understanding of science. 
                </p>
            </div>
        </div>
         <div class="row pt-5 pb-5">
            <div class="col-12 col-md-6">
                <img class="img-fluid" src='../assets/paul.jpg' alt="Yuti Chernajovsky">
            </div>
            <div class="col-12 col-md-6 mt-3 mt-md-0">
                <strong class="fs14 fs-sm-12">Paul-Peter Tak, MD PhD FMedSci</strong>
                <p class="pt-2">
                    is President & CEO of Candel Therapeutics and Honorary Senior Visiting Fellow at the University of Cambridge.
                    Previously, he was Professor of Medicine at the Amsterdam University Medical Centre (AMC),
                    Senior Vice President, Chief Immunology Officer, and Global Development Leader at GlaxoSmithKline, and Venture Partner at Flagship Pioneering.
                    He is board director and co-founder of Sitryx Therapeutics (Oxford), and board director of Levicept (London) and Citryll (Oss). 
                    He has published extensively in peer-reviewed journals, received numerous awards, has been elected Fellow of the Academy of Medical Sciences,
                    and was recognized by PharmaVOICE100 (100 most inspiring people in life sciences) in 2021.
                </p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Image from '../assets/about.jpg';
import Hero from './Hero.vue'

export default {
  name: 'app',
  data() {
    return{
      Image
    }
  },
  components: {
    Hero
  }
}
</script>